import { propEq } from "ramda";
import { Tr, Th, Td } from "./measurementstable.styles";
import { allGenderTypes } from "utils/genders";
import { translateDateToPeriod } from "utils/periods";
import { getIsoDate } from "utils/dates";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function MeasurementsTableHeader(props) {
  var query = props.query,
    dates = props.dates,
    activeFilters = props.activeFilters,
    availableFilters = props.availableFilters,
    periodSpan = props.periodSpan,
    multipleGenders = props.multipleGenders,
    measureIds = props.measureIds,
    measure = props.measure;
  var periodColumns = function periodColumns() {
    var periodHeaders = dates.map(function (period) {
      var periodLabel = translateDateToPeriod(query.periodType, period.end);
      return /*#__PURE__*/_jsx(Th, {
        scope: "colgroup",
        type: "period",
        colSpan: periodSpan,
        children: periodLabel
      }, getIsoDate(period.end));
    });
    return /*#__PURE__*/_jsxs(Tr, {
      "aria-rowindex": 1,
      children: [/*#__PURE__*/_jsx(Td, {
        "aria-colindex": "1",
        rowSpan: measureIds.length + 1
      }), periodHeaders]
    });
  };
  var genderColumns = function genderColumns() {
    if (!multipleGenders) return null;
    var genderHeaders = dates.map(function (period) {
      var periodLabel = translateDateToPeriod(query.periodType, period.end);
      return measureIds.map(function (id) {
        var _measure$submeasures, _measure$submeasures$;
        var gender = allGenderTypes[measure === null || measure === void 0 ? void 0 : (_measure$submeasures = measure.submeasures) === null || _measure$submeasures === void 0 ? void 0 : (_measure$submeasures$ = _measure$submeasures.find(propEq("measureId", id))) === null || _measure$submeasures$ === void 0 ? void 0 : _measure$submeasures$.gender];
        return /*#__PURE__*/_jsx(Th, {
          scope: "colgroup",
          type: "gender",
          colSpan: activeFilters.length,
          children: gender
        }, "".concat(gender, "-").concat(periodLabel));
      });
    });
    return /*#__PURE__*/_jsx(Tr, {
      "aria-rowindex": 2,
      children: genderHeaders
    });
  };
  var measurementsColumns = function measurementsColumns() {
    var measurementsHeaders = dates.map(function (period, periodIdx) {
      var periodLabel = translateDateToPeriod(query.periodType, period.end);
      return measureIds.map(function (measureId, measureIdx) {
        return availableFilters.map(function (x, filterIdx) {
          return /*#__PURE__*/_jsx(Th, {
            scope: "col",
            type: "propType",
            borderMe: filterIdx === 0,
            "aria-colindex": periodIdx * measureIds.length * availableFilters.length + measureIdx * availableFilters.length + (filterIdx + 2),
            style: activeFilters.includes(x.id) ? {} : {
              display: "none"
            },
            children: x.label
          }, "".concat(x.id, "-").concat(periodLabel, "-").concat(measureId));
        });
      });
    });
    return /*#__PURE__*/_jsx(Tr, {
      "aria-rowindex": multipleGenders ? 3 : 2,
      children: measurementsHeaders
    });
  };
  return /*#__PURE__*/_jsxs("thead", {
    children: [periodColumns(), genderColumns(), measurementsColumns()]
  });
}